import { useEffect, useState } from "react";
import { Users, BookOpen, Upload } from "lucide-react";
import { api } from "../../lib/api";

export default function Dashboard() {
    const [data, setData] = useState(null);
    useEffect(() => {
        api.get("/dashboards/me").then((r) => setData(r.data));
    }, []);
    if (!data) return <div className="p-6 text-edu-muted">Cargando…</div>;
    const { user, stats, recent_students } = data;

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="profesor-dashboard">
            <h1 className="text-3xl font-semibold mb-1">¡Bienvenido/a, Profesor/a {user.name}! 👋</h1>
            <p className="text-edu-body mb-7">Aquí tienes un resumen de tu actividad.</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
                <Stat icon={Users} label="Total de Alumnos" value={stats.total_students} />
                <Stat icon={BookOpen} label="Total de Clases" value={stats.total_classes} />
                <Stat icon={Upload} label="Materiales Subidos" value={stats.materials} />
            </div>

            <div className="edu-card p-6">
                <h3 className="text-lg font-semibold mb-4">Alumnos Recientes</h3>
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-left border-b border-edu">
                                <th className="py-2 font-semibold">Alumno</th>
                                <th className="py-2 font-semibold">Clase</th>
                                <th className="py-2 font-semibold">Progreso</th>
                                <th className="py-2 font-semibold">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recent_students.map((s) => (
                                <tr key={s.id} className="border-b border-edu/50">
                                    <td className="py-3">
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-full bg-edu-navy/10 text-edu-navy flex items-center justify-center font-semibold text-xs">
                                                {s.name.split(" ").map((p) => p[0]).slice(0, 2).join("")}
                                            </div>
                                            {s.name}
                                        </div>
                                    </td>
                                    <td className="py-3 text-edu-muted">{s.grade || "—"}</td>
                                    <td className="py-3 w-1/3">
                                        <div className="flex items-center gap-2">
                                            <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                                                <div
                                                    className="h-full bg-emerald-500"
                                                    style={{ width: `${s.progress}%` }}
                                                />
                                            </div>
                                            <span className="text-xs text-edu-muted w-8 text-right">
                                                {s.progress}%
                                            </span>
                                        </div>
                                    </td>
                                    <td className="py-3">
                                        <span
                                            className={`edu-pill ${s.active ? "bg-emerald-100 text-emerald-800" : "bg-gray-100 text-gray-600"}`}
                                        >
                                            {s.active ? "Activo" : "Inactivo"}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                            {recent_students.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="py-6 text-center text-edu-muted">
                                        Sin alumnos asignados.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

function Stat({ icon: Icon, label, value }) {
    return (
        <div className="edu-card p-6 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-edu-navy/10 flex items-center justify-center">
                <Icon size={22} className="text-edu-navy" />
            </div>
            <div>
                <div className="text-xs uppercase tracking-widest font-semibold text-edu-muted">{label}</div>
                <div className="text-3xl font-bold mt-1">{value}</div>
            </div>
        </div>
    );
}
